<template>
  <v-app>
    <div style="position: fixed; height: 100vh; background-color: #222">
      <v-img src="@/assets/login.jpg" width="100vw" cover />
    </div>
    <v-container id="fundo" class="p-0 fill-height" fluid>
      <v-row class="layout-login-row">
        <v-col cols="12" :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''">
          <v-row class="fill-height" align="center" justify="center">
            <v-col cols="12" sm="8" md="5" lg="4" style="padding: 0px">
              <v-container
                :style="$vuetify.breakpoint.xs ? 'padding: 4px' : ''"
              >
                <v-card color="white" style="padding: 12px">
                  <v-container class="pb-2">
                    <v-row
                      class="layout-logos-login fill-height px-4 height"
                      align="center"
                      justify="center"
                    >
                      <v-img
                        class="logo-form-login educampo"
                        src="img/milk-plan.png"
                        height="120px"
                        contain
                      />
                    </v-row>
                  </v-container>
                  <div v-if="!loader">
                    <v-form
                      id="form_alterarSenha"
                      ref="form_alterarSenha"
                      v-model="valid"
                      @submit.prevent="submitResetar"
                    >
                      <v-container class="p-4">
                        <v-text-field
                          v-model="senha"
                          light
                          prepend-inner-icon="mdi-key"
                          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                          :rules="[rules.required]"
                          :type="show2 ? 'text' : 'password'"
                          name="senha"
                          label="Senha"
                          counter
                          @click:append="show2 = !show2"
                        />
                        <v-text-field
                          v-model="senhaConfirme"
                          light
                          prepend-inner-icon="mdi-key"
                          :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                          :rules="[rules.required]"
                          :type="show3 ? 'text' : 'password'"
                          name="senhaConfirme"
                          label="Confirme Sua Senha"
                          counter
                          @click:append="show3 = !show3"
                        />
                        <v-row justify="center" class="pt-2">
                          <v-btn color="success" class="mr-4" type="submit">
                            Alterar
                          </v-btn>
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                  <v-container v-else class="pa-6">
                    <v-row justify="space-around">
                      <v-progress-circular
                        :size="100"
                        :width="7"
                        color="primary"
                        :indeterminate="true"
                      />
                    </v-row>
                  </v-container>
                </v-card>
              </v-container>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        multi-line
        top
        :timeout="3500"
        color="error"
      >
        {{ message }}
        <v-btn dark flat @click="snackbar = false"> Fechar </v-btn>
      </v-snackbar>
    </v-container>
  </v-app>
</template>
<script>
export default {
  props: {
    backgroundImage: {
      type: String,
      default: 'static/img/login.jpg',
    },
  },
  data() {
    return {
      senha: null,
      senhaConfirme: null,
      requiredRules: [v => !!v || ''],
      user: null,
      snackbar: false,
      message: '',
      loader: false,
      valid: null,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
      },
    }
  },
  created() {
    localStorage.clear()
    this.api.defaults.headers.common.Authorization = ''
    this.verificaToken()
  },
  methods: {
    alterarSenha() {
      this.loader = true
      this.api
        .post('/redefinir-senha', {
          email: this.email,
          senha: this.senha,
          senhaConfirme: this.senhaConfirme,
        })
        .then(() => {
          this.Swal.fire({
            title: 'Senha alterada com sucesso!',
            icon: 'success',
          })
          this.$router.push('/login')
        })
        .catch(error => {
          this.Swal.fire({
            icon: 'error',
            title: 'Erro',
            html: error.response.data.errors.reduce(
              (curr, acc) => acc + curr + '<br>',
              '',
            ),
          })
          this.loader = false
        })
    },
    verificaToken() {
      this.api
        .post('/verificar-token', {
          username: this.$route.params.email,
          token: this.$route.params.token,
        })
        .then(response => {
          if (!response.data) {
            this.Swal.fire({
              allowOutsideClick: false,
              title: 'Token Inválido',
              text:
                'Seu token expirou, por favor, solicite uma nova requisição de troca de senha clicando no botão abaixo',
              type: 'error',
              confirmButtonText: 'Novo Token',
            }).then(result => {
              if (result.value) {
                this.$router.push('/recuperar-senha')
              }
            })
          } else {
            this.loader = false
          }
        })
        .catch(() => {
          // console.log(error)
        })
    },
    submitResetar() {
      this.$refs.form_alterarSenha.validate()
      if (!this.valid) {
        this.message = 'Por favor, insira as senhas'
      } else {
        this.loading = true
        this.api
          .post('/alterar-senha', {
            username: this.$route.params.email,
            senha: this.senha,
            senhaConfirme: this.senhaConfirme,
          })
          .then(response => {
            if (response.data.error) {
              let erros = ''
              response.data.message.forEach(el => {
                erros += el + '<br/>'
              })
              this.Swal.fire('Erro', erros, 'error')
              this.loader = false
            } else {
              this.Swal.fire('Senha Alterada!', '', 'success')
              this.$router.push('/login')
            }
          })
          .catch(() => {
            this.loading = false
            // console.log(error)
          })
      }
    },
  },
}
</script>
<style scope lang="scss">
.senha {
  color: rgb(40, 57, 211);
}
.senha:hover {
  color: rgb(29, 115, 245);
}

.outline-login .container .v-input .v-input__control .v-input__slot {
  border: 2px solid #005bb9;
}

.logo-form-login.educampo .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

.logo-form-login.sebrae .v-image__image--cover {
  background-size: contain;
  background-position: center !important;
}

html {
  overflow: auto;
}

.headline {
  font-family: 'Poppins', sans-serif !important;
}

.display-grid {
  display: grid;
  height: auto !important;
  .flex {
    background-color: white;
    padding: 7px;
    margin-bottom: 70%;
    .v-responsive.v-image {
      margin-top: 6px;
      padding: 0px 0.7px;
    }
  }
}

.apresentacao {
  font-size: 24px;
  font-family: 'Poppins', sans-serif;
}

.layout-login-row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

@media (min-width: 41em) {
  #fundo {
    background-size: auto;
  }
} /* 656px */

@media (min-width: 47em) {
  #fundo {
    background-size: auto;
  }
} /* 752px */

@media (min-width: 68em) {
  #fundo {
    background-size: auto;
  }
} /* 1088px */

@media (min-width: 82em) {
  #fundo {
    background-size: auto;
  }
} /* 1312px */

@media (min-width: 100em) {
  #fundo {
    background-size: contain;
  }
  .layout-logos-login {
    align-items: center !important;
  }
  .tela-login.flex .v-card {
    height: 316px;
  }
  .headline {
    font-size: 34px !important;
  }
  .logo-form-login.educampo {
    height: 110px !important;
  }
  .logo-form-login.sebrae {
    height: 70px !important;
    padding-bottom: 20px;
  }
} /* 1600px */
</style>
